<div class="tags-content">
  <div *ngFor="let label of labels"
       class="tag select"
       [ngClass]="'tag-wv-tool-tag-blue'">
    {{label}}
  </div>
</div>
